<h1 mat-dialog-title>
  {{ "bulk-reassign.Case-Reassign" | translate }}
</h1>
<div mat-dialog-content class="bulk-reassign max-height-77-vh">
  <!-- <dynamic-grid
    #dynamicGrid
    [rows]="rows"
    [cols]="cols"
    [showSearch]="false"
    [gridFooterActions]="false"
    [beginWithAddedRow]="true"
    (onInputChange)="onInputChange($event)"
    (onCustomComponentOutput)="onCustomOutput($event)"
  >
  </dynamic-grid> -->

  <mat-card class="main-card bluk-reassign-card">
    <div class="row w-100">
      <div class="col-md-2 d-flex align-items-center justify-content-center">
        <mat-label class="Reassign_Case_to_label_Class common-label">{{
          "bulk-reassign.Case-Reassign-to" | translate
        }}</mat-label>
      </div>
      <div class="col-md-10">
        <mat-radio-group
          [(ngModel)]="reassignTo"
          [ngModelOptions]="{ standalone: true }"
          (change)="onReassignToChange()"
          [disabled]="this?.data?.disableAssignToSelection"
        >
          <mat-radio-button value="1">{{
            "bulk-reassign.Group_trays" | translate
          }}</mat-radio-button>
          <mat-radio-button class="ms-3" value="2">{{
            "bulk-reassign.Employee" | translate
          }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <mat-card-content class="w-100 mt-2 max-height-75-vh">
      <div class="row max-height-57-vh">
        <div class="col-md-6 h-100">
          <mat-card class="filter-card h-100 w-100">
            <mat-card-content class="filter-content w-100">
              <p class="dg-txt-primary dg-fs-14">
                {{
                  this.reassignTo == "1"
                    ? ("bulk-reassign.Select_Group_trays" | translate)
                    : ("bulk-reassign.Filters" | translate)
                }}
              </p>
              <div class="mt-3">
                <div class="row m-0">
                  <div class="col-md-12 p-0">
                    <ng-select
                      appearance="fill"
                      [items]="grpCombo"
                      bindLabel="optionText"
                      bindValue="optionValue"
                      [(ngModel)]="selectedGrp"
                      placeholder="{{
                        'bulk-reassign.Group_trays' | translate
                      }}"
                      appendTo="body"
                      (change)="onGrpChange()"
                      [clearable]="true"
                      [disabled]="this.data?.disableGrpSelection"
                    >
                    </ng-select>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6 h-100">
          <p class="dg-txt-primary dg-fs-14 mb-0 margin-top-10 subTitleName">
            {{ "bulk-reassign.Search_Emp" | translate }}
          </p>
          <mat-form-field class="bulk-reassign-search-employee w-100">
            <mat-label></mat-label>
            <input sanitized
              matInput
              placeholder="{{ 'bulk-reassign.Search_Emp' | translate }}"
              (keyup)="onKeyUp()"
              [(ngModel)]="searchVal"
            />
            <mat-icon
              class="search-mat-icon dg-txt-primary"
              (click)="getEmployeeList()"
              matSuffix
              >search</mat-icon
            >
          </mat-form-field>
          <mat-card class="w-100 pt-0 height-45-vh">
            <mat-card-content class="w-100 h-100">
              <mat-radio-group
                class="radio-group"
                (change)="selectionChange($event)"
                [(ngModel)]="this.selectedUnit"
                [disabled]="this.reassignTo == '1' ? true : false"
              >
                <mat-list
                  class="emp-radio-selection empListClass"
                  [ngClass]="{
                    empListClassGrp: this.selectedGrp,
                    empListClassUnit: !this.selectedGrp
                  }"
                >
                  <mat-list-item class="w-100" *ngFor="let employee of empList">
                    <div class="d-flex py-2 align-items-center w-100">
                      <div
                        matTooltip="You can not be able select User as you have selected reassign to as an Group"
                        [matTooltipDisabled]="
                          this.reassignTo == '2' ? true : false
                        "
                      >
                        <mat-radio-button [value]="employee"></mat-radio-button>
                      </div>
                      <div class="ms-3 d-flex flex-column">
                        <div class="employee-name dg-fs-16">
                          {{ employee?.FULL_NAME + " - " + employee?.EMAIL_ID }}
                        </div>
                        <div class="employee-org dg-fs-14">
                          {{
                            employee?.DSGN_NAME + ", " + employee?.ORG_SHRT_NAME
                          }}
                        </div>
                      </div>
                    </div>
                  </mat-list-item>
                </mat-list>
              </mat-radio-group>
              <mat-paginator
                *ngIf="!this.selectedGrp"
                class="emp-search-pagination d-inline col-md-12"
                #matpagination
                [length]="totalRecord"
                [pageSize]="pageSize"
                (page)="onPageChange($event)"
              >
              </mat-paginator>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-raised-button mat-dialog-close>
      {{ "send_Within.Cancel" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      preventDoubleClick
      (click)="onSend()"
      [disabled]="isSendDisabled()"
    >
      {{ "send_Within.SendIt" | translate }}
    </button>
  </div>
</mat-dialog-actions>
